import {connect} from 'react-redux'
import withRouter from "../../../components/RouterComponentWrapper";
import GameWatchView from "../../../components/views/training/GameWatchView";

const mapStateToProps = function (state, ownProps) {
    const urlParams = new URLSearchParams(ownProps.router.location.search);
    const gameId = urlParams.get('gameid');
    return {gameid: gameId};
};

const mapDispatchToProps = dispatch => ({
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(GameWatchView))